import { useFormContext } from 'react-hook-form';
import { TagsFormBody } from 'src/components/TagsFormBody';
import { Content } from 'src/contexts/ContentContext';
import { useUserCanUpdateListingTags } from 'src/hooks/useUserHasListingPermissions';
import { DetailSection } from 'src/modals/common';
import { ContentId } from 'src/utils/constants/contentId';
import {
  ActionOutboxEntityType,
  ListingDetails,
  ListingDetailsTagsSectionUpdates,
  Tag,
} from 'src/WebApiController';

type TagsTabProp = {
  listing: ListingDetails | null;
  disabled?: boolean;
  isBulkEdit?: boolean;
};

export const TagsSection: React.FC<TagsTabProp> = ({
  listing,
  disabled,
  isBulkEdit = false,
}) => {
  const { setValue, watch } =
    useFormContext<ListingDetailsTagsSectionUpdates>();
  const tags = watch('tags') ?? [];

  const canEditTags = useUserCanUpdateListingTags(listing, isBulkEdit);

  const onTagsUpdate = (tags: Tag[]) => {
    if (
      listing != null &&
      !!listing?.purchaseInfos?.length &&
      tags.some((t) => t.persistentTagId != null && t.sourceEntityId == null)
    ) {
      // Need to populate the sourceEntityId by looking at the purchaseOrderIds
      const newTags = tags.filter(
        (t) => t.persistentTagId == null || t.sourceEntityId != null
      );

      const purchaseOrderIds = Array.from(
        new Set(listing.purchaseInfos.map((p) => p.purchaseOrderId))
      );
      tags
        .filter((t) => t.persistentTagId != null && t.sourceEntityId == null)
        .forEach((t) => {
          purchaseOrderIds.forEach((purchaseOrderId) => {
            newTags.push({
              ...t,
              sourceEntityId: purchaseOrderId,
            });
          });
        });

      setValue('tags', newTags);
    } else {
      setValue('tags', tags);
    }
  };

  return (
    <DetailSection name={<Content id={ContentId.Tags} />}>
      <TagsFormBody
        canEditTags={canEditTags}
        tagsCurrentEntity={tags}
        onTagsUpdate={onTagsUpdate}
        disabled={disabled}
        entityType={ActionOutboxEntityType.Listing}
      />
    </DetailSection>
  );
};
